import React from 'react'
import SuperUserSettingsPageUI from '../../../templates/SuperUserSettingsPageUI.js'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import UserListUI from '../../../components/superUser/settings/UserListUI'
import UserCreateModalSF from '../../../components/superUser/settings/UserCreateModalSF'
import UserUpdateModalSF from '../../../components/superUser/settings/UserUpdateModalSF'
import UserDeleteModalSF from '../../../components/superUser/settings/UserDeleteModalSF'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const UserListPageUI = ({context, userList,
    // form
    successMsg, errorList, setErrorList,
    // modes
    selectedCount, createMode, updateMode, deleteMode,
    // event handlers
    onRowClick, onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick,
    // event handlers in modals
    onCancelClick,
    // update form
    selectedUser
  }) =>
  <SuperUserSettingsPageUI context={context} className='pg_su_usrs' topnav='settings' backLink='/su/settings'
    headerText='Users' centered={!userList && !errorList} page='users'
  >
    {
      !userList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      userList && userList.length !== 0 &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/su/settings' titleText='Users' />
        <UserListUI
          context={context}
          userList={userList}
          //
          selectedCount={selectedCount}
          onRefreshClick={onRefreshClick}
          onCreateClick={onCreateClick}
          onUpdateClick={onUpdateClick}
          onDeleteClick={onDeleteClick}
          onRowClick={onRowClick}
        />
      </div>
    }

    <UserCreateModalSF
      context={context}
      createMode={createMode}
      onCancelClick={onCancelClick}
      onRefreshClick={onRefreshClick}
    />

    <UserUpdateModalSF
      context={context}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      updateMode={updateMode}
      onCancelClick={onCancelClick}
      onRefreshClick={onRefreshClick}
      selectedUser={selectedUser}
    />

    <UserDeleteModalSF
      context={context}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      deleteMode={deleteMode}
      onCancelClick={onCancelClick}
      onRefreshClick={onRefreshClick}
      selectedUser={selectedUser}
    />
  </SuperUserSettingsPageUI>

export default UserListPageUI
